import styled from "styled-components";

export const Container = styled.div`
  border: 1px solid #203b34;
  padding: 20px 20px;
  border-radius: 10px;
`;

export const Subtitle = styled.div`
  font-size: 1.2rem;
  text-decoration: underline;
  margin-bottom: 10px;
`;

export const FinishStep = styled.div`
  font-size: 1rem;
  color: red;
  margin-bottom: 10px;
  font-weight: bold;
`;

// export const PageHeader2 = styled.div`
//   background: white;
//   border-radius: 12px;
//   padding: 24px;
//   margin-bottom: 30px;
//   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

//   h2 {
//     color: #203b34;
//     font-size: 24px;
//     font-weight: 600;
//     margin: 0 0 8px 0;
//   }

//   p {
//     color: #6c757d;
//     margin: 0;
//     font-size: 14px;
//   }
//   div {
//     margin: 0;
//     padding: 0;
//     justify-content: left;
//   }

//   h3 {
//     color: #203b34;
//     font-size: 28px;
//     font-weight: 600;
//     margin: 0 0 8px 0;
//   }
// `;
export const PageHeader = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 100%;

  h2 {
    color: #203b34;
    font-size: 24px;
    font-weight: 600;
    margin: 0 0 8px 0;
  }

  p {
    color: #6c757d;
    margin: 0;
    font-size: 14px;
  }
  div {
    margin: 0;
    padding: 0;
    justify-content: left;
  }
  h3 {
    color: #203b34;
    font-size: 28px;
    font-weight: 600;
    margin: 0 0 8px 0;
  }
`;

export const ListContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const BreadcrumbDiv = styled.div`
  margin: 0 !important;
  padding: 0 !important;

  .row {
    margin: 0 !important;
    justify-content: flex-start !important;
  }

  .breadcrumb {
    margin: 0 !important;
    padding: 0 !important;
    background: transparent !important;
  }

  .breadcrumb-item {
    margin: 0 !important;
    padding: 0 !important;
  }
`;

export const ContentCard = styled.div`
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 25px;
  margin-bottom: 20px;
  height: auto;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    padding: 15px;
    height: auto;
    min-height: 300px;
  }
`;

export const SupplierSection = styled.div``;

export const TabContainer = styled.div`
  display: flex;
  /* border-bottom: 2px solid #e0e0e0; */
  /* margin-bottom: 25px; */
  gap: 5px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 8px;
    /* margin-bottom: 15px; */
  }
`;

export const Tab = styled.button`
  background-color: ${({ $active }) => ($active ? "#203b34" : "transparent")};
  color: ${({ $active }) => ($active ? "#ffffff" : "#666")};
  border: none;
  /* border-bottom: 3px solid
    ${({ $active }) => ($active ? "#f9ae17" : "transparent")}; */
  padding: 12px 24px;
  font-size: 0.95rem;
  font-weight: ${({ $active }) => ($active ? "600" : "500")};
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 4px 4px 4px 4px;

  &:hover {
    background-color: ${({ $active }) => ($active ? "#203b34" : "#f5f5f5")};
    color: ${({ $active }) => ($active ? "#ffffff" : "#203b34")};
  }

  i {
    font-size: 0.9rem;
  }

  @media (max-width: 768px) {
    padding: 8px 12px;
    font-size: 0.85rem;
    flex: 1;
    text-align: center;

    i {
      font-size: 0.8rem;
      margin-right: 4px !important;
    }
  }
`;

export const TabContent = styled.div`
  padding: 10px 0;
  overflow-y: auto;
  max-height: calc(500px - 150px);

  @media (max-width: 768px) {
    max-height: none;
    overflow-y: visible;
  }
`;
